import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class WalletInfoApi extends CrudBase {
	getWalletInfo = (params) => axios.get(`${this.endpoint}/get-by`, params);

	defaultMethods = {
		getWalletInfo: this.getWalletInfo,
	};
}

const walletInfo = new WalletInfoApi('api/v1/wallet-info');

export default walletInfo.defaultMethods;
